import React from 'react';
import PropTypes from 'prop-types';
import { RenderModule } from 'holocron';
import { useHolocronState } from '../hooks/useHolocronState';

const GlobalNavigationWrapper = ({ children, location }) => {
  const state = useHolocronState();
  const { config } = state;
  const domain = config.consumerUrlHostname;
  const url = new URL(location.pathname, domain);
  const queryParams = new URLSearchParams(location.query);
  const fullUrl = `${url}?${queryParams.toString()}`;

  // Removed isGlobalHeaderLoaded an isGlobalFooterLoaded so that
  // client side module render will work.

  return (
    <>
      <RenderModule
        props={{ loginDestPage: fullUrl, logoutDestPage: fullUrl }}
        moduleName="axp-global-header"
      />
      {children}
      <RenderModule moduleName="axp-footer" />
    </>
  );
};

GlobalNavigationWrapper.propTypes = {
  children: PropTypes.node,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    query: PropTypes.shape({
      eep: PropTypes.string,
    }),
  }),
  route: PropTypes.shape({
    store: PropTypes.shape({
      getState: PropTypes.func,
    }),
  }),
};

GlobalNavigationWrapper.defaultProps = {
  children: null,
};

export default GlobalNavigationWrapper;
